import * as React from "react";

export const Warning = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34556 3.29076C8.1912 3.02615 7.80888 3.02615 7.65453 3.29075L2.39557 12.3061C2.24002 12.5728 2.43237 12.9077 2.74108 12.9077H13.259C13.5677 12.9077 13.7601 12.5728 13.6045 12.3061L8.34556 3.29076ZM6.618 2.68611C7.2354 1.6277 8.76469 1.6277 9.38209 2.68611L14.6411 11.7015C15.2633 12.7681 14.4939 14.1077 13.259 14.1077H2.74108C1.50622 14.1077 0.736823 12.7681 1.35904 11.7015L6.618 2.68611ZM7.11048 6.50155C7.05157 5.97136 7.46659 5.50767 8.00004 5.50767C8.5335 5.50767 8.94852 5.97136 8.88961 6.50155L8.55526 9.51073C8.52383 9.79364 8.2847 10.0077 8.00004 10.0077C7.71539 10.0077 7.47626 9.79364 7.44483 9.51073L7.11048 6.50155ZM8.00004 12.0077C8.41426 12.0077 8.75004 11.6719 8.75004 11.2577C8.75004 10.8435 8.41426 10.5077 8.00004 10.5077C7.58583 10.5077 7.25004 10.8435 7.25004 11.2577C7.25004 11.6719 7.58583 12.0077 8.00004 12.0077Z"
    />
);

export const WarningSmall = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.06494C7.46396 4.06494 7.04451 4.52676 7.09595 5.06033L7.45202 8.75426C7.47923 9.03653 7.71642 9.25195 8 9.25195C8.28358 9.25195 8.52076 9.03653 8.54797 8.75426L8.90405 5.06033C8.95548 4.52676 8.53604 4.06494 8 4.06494ZM8 11.9351C8.41421 11.9351 8.75 11.5993 8.75 11.1851C8.75 10.7709 8.41421 10.4351 8 10.4351C7.58579 10.4351 7.25 10.7709 7.25 11.1851C7.25 11.5993 7.58579 11.9351 8 11.9351Z"
    />
);
